import React from 'react';

export const CustomHeroContext = React.createContext({
  activePage: null,
  displayVideoPlayerEditor: false,
  activePatch: null,
});

export const CustomHeroProvider = CustomHeroContext.Provider;
